var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parallax-container"},[_c('div',{ref:"parallax",staticClass:"parallax"},[_c('img',{attrs:{"src":require('../assets/' + _vm.image),"alt":_vm.description}})])])}
var staticRenderFns = []

export { render, staticRenderFns }